export const iconFontAwesomeMedicalHealthFireFlameSimple = (
	<i className="fa-solid fa-fire-flame-simple"></i>
);
